import axios from 'axios';

// Try both CRA standard and custom env variable names
const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY || 
                            process.env.UNSPLASH_ACCESS_KEY ||
                            ''; // Fallback empty - will be skipped
const UNSPLASH_API_URL = 'https://api.unsplash.com';

// Check if API key is available
const isApiKeyConfigured = () => {
  return !!UNSPLASH_ACCESS_KEY && UNSPLASH_ACCESS_KEY.length > 10;
};


class UnsplashService {
  constructor() {
    this.client = axios.create({
      baseURL: UNSPLASH_API_URL,
      headers: {
        Authorization: `Client-ID ${UNSPLASH_ACCESS_KEY}`,
      },
    });
  }

  async searchHotelImages(query, perPage = 1) {
    // Check if API key is configured
    if (!isApiKeyConfigured()) {
      console.warn('Unsplash API key not configured. Skipping image fetch.');
      return [];
    }

    try {
      const response = await this.client.get('/search/photos', {
        params: {
          query: `${query} hotel interior`,
          per_page: perPage,
          orientation: 'landscape',
        },
      });
      return response.data.results;
      
    } catch (error) {
      // Log more detailed error info
      if (error.response?.status === 401) {
        console.error('Unsplash API authentication failed. Please check your API key.');
      } else if (error.response?.status === 403) {
        console.error('Unsplash API rate limit exceeded or access denied.');
      } else {
        console.error('Error fetching Unsplash images:', error.message);
      }
      return [];
    }
  }

  async getRandomHotelImage(query) {
    // Check if API key is configured
    if (!isApiKeyConfigured()) {
      console.warn('Unsplash API key not configured. Skipping image fetch.');
      return null;
    }

    try {
      const response = await this.client.get('/photos/random', {
        params: {
          query: `${query} hotel`,
          orientation: 'landscape',
          count: 1,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching random Unsplash image:', error.message);
      return null;
    }
  }

  // Helper to generate a search query from hotel data
  buildHotelQuery(hotelName, location) {
    const cleanLocation = location?.split('(')[0].trim() || '';
    const cleanName = hotelName?.replace(/\s+hotel\s*$/i, '').trim() || '';
    return `${cleanName} ${cleanLocation}`.trim();
  }

  // Check if Unsplash is configured
  isConfigured() {
    return isApiKeyConfigured();
  }
}

export default new UnsplashService();

      
